import { I18n } from "i18n-js"

const locale = document.documentElement.lang

// async function loadTranslations(i18n, locale) {
//   let [response, editorResponse] = await Promise.all([fetch(`/locales/${locale}.json`), fetch(`/locales/editor/${locale}.json`)]);
//   let [translations, rawEditorTranslations] = await Promise.all([response.json(), editorResponse.json()]);
//   const editorTranslations = { [locale]: rawEditorTranslations }

//   i18n.store(translations);
//   i18n.store(editorTranslations);
// }

const translations = require(`../../../public/locales/${locale}.json`)
const rawEditorTranslations = require(`../../../public/locales/editor/${locale}.json`)
const editorTranslations = { [locale]: rawEditorTranslations }

const i18n = new I18n({
  [locale]: {
    ...translations[locale],
    ...editorTranslations[locale],
  }
})

i18n.locale = locale
i18n.defaultLocale = "en"
window.I18n = i18n
// loadTranslations(i18n, locale);
